export function buildDashboardPageURL() {
  return '/dashboard'
}
